import { MasterDataCareerCertification } from "@/features/master-data/components/CareerCertification/MasterDataCareerCertification";
import { MasterDataCompanySpecificIndustry } from "@/features/master-data/components/CompanySpecificIndustry/MasterDataCompanySpecificIndustry";
import { MasterDataJobType } from "@/features/master-data/components/JobType/MasterDataJobType";
import { MasterDataLanguageTest } from "@/features/master-data/components/LanguageTest/MasterDataLanguageTest";
import { MasterDataLivingRelationship } from "@/features/master-data/components/LivingRelationship/MasterDataLivingRelationship";
import { MasterDataLocalGovernmentCounter } from "@/features/master-data/components/LocalGovernmentCounter/MasterDataLocalGovernmentCounter";
import { MasterDataMainIndustry } from "@/features/master-data/components/MainIndustry/MasterDataMainIndustry";
import { MasterDataMainOccupation } from "@/features/master-data/components/MainOccupation/MasterDataMainOccupation";
import { MasterDataOccupation } from "@/features/master-data/components/Occupation/MasterDataOccupation";
import { MasterDataNationality } from "@/features/master-data/components/Nationality/MasterDataNationality";
import { MasterDataResidencePeriod } from "@/features/master-data/components/ResidencePeriod/MasterDataResidencePeriod";
import { MasterDataSkillTest } from "@/features/master-data/components/SkillTest/MasterDataSkillTest";
import { MasterDataSpecificActivityOccupation } from "@/features/master-data/components/SpecificActivityOccupation/MasterDataSpecificActivityOccupation";
import { MasterDataSpecificIndustry } from "@/features/master-data/components/SpecificIndustry/MasterDataSpecificIndustry";
import { MasterDataStandardIndustry } from "@/features/master-data/components/StandardIndustry/MasterDataStandardIndustry";
import { MasterDataSupportLanguage } from "@/features/master-data/components/SupportLanguage/MasterDataSupportLanguage";
import { MASTER_DATA_TYPE } from "@/features/master-data/constants/masterDataType";
import FeatureNotReadyPage from "@/pages/FeatureNotReadyPage";
import { FC, useMemo } from "react";
import { useParams } from "react-router-dom";

export const MasterDataDetailPage: FC = () => {
  const { type: masterDataType } = useParams();

  const MasterDataDetailComponent = useMemo(() => {
    switch (masterDataType) {
      case MASTER_DATA_TYPE.NATIONALITY:
        return <MasterDataNationality />;
      case MASTER_DATA_TYPE.LIVING_RELATIONSHIP:
        return <MasterDataLivingRelationship />;
      case MASTER_DATA_TYPE.MAIN_OCCUPATION:
        return <MasterDataMainOccupation />;
      case MASTER_DATA_TYPE.SPECIFIC_ACTIVITY_OCCUPATION:
        return <MasterDataSpecificActivityOccupation />;
      case MASTER_DATA_TYPE.CAREER_CERTIFICATION:
        return <MasterDataCareerCertification />;
      case MASTER_DATA_TYPE.LANGUAGE_TEST:
        return <MasterDataLanguageTest />;
      case MASTER_DATA_TYPE.SKILL_TEST:
        return <MasterDataSkillTest />;
      case MASTER_DATA_TYPE.SUPPORT_LANGUAGE:
        return <MasterDataSupportLanguage />;
      case MASTER_DATA_TYPE.MAIN_INDUSTRY:
        return <MasterDataMainIndustry />;
      case MASTER_DATA_TYPE.COMPANY_SPECIFIC_INDUSTRY:
        return <MasterDataCompanySpecificIndustry />;
      case MASTER_DATA_TYPE.MASTER_OCCUPATION:
        return <MasterDataOccupation />;
      case MASTER_DATA_TYPE.JOB_TYPE:
        return <MasterDataJobType />;
      case MASTER_DATA_TYPE.SPECIFIC_INDUSTRY:
        return <MasterDataSpecificIndustry />;
      case MASTER_DATA_TYPE.RESIDENCE_PERIOD:
        return <MasterDataResidencePeriod />;
      case MASTER_DATA_TYPE.LOCAL_GOVERNMENT_COUNTER:
        return <MasterDataLocalGovernmentCounter />;
      case MASTER_DATA_TYPE.STANDARD_INDUSTRY:
        return <MasterDataStandardIndustry />;

      default:
        return <FeatureNotReadyPage />;
    }
  }, [masterDataType]);

  return <>{MasterDataDetailComponent}</>;
};
